/* ZNS Universe - fallback starfield + perf-tuned harmonizer/reskin for ZOOMNSTORE.
   Background is normally owned by zns-shader.js (loads first, sets __znsUniverse). */
(function () {
  'use strict';
  if (window.__znsUniverse) return;
  window.__znsUniverse = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    var stage = document.createElement('div');
    stage.className = 'zns-stage';
    stage.setAttribute('aria-hidden', 'true');
    stage.innerHTML =
      '<canvas></canvas>' +
      '<div class="zns-blob zns-b1"></div>' +
      '<div class="zns-blob zns-b2"></div>' +
      '<div class="zns-blob zns-b3"></div>' +
      '<div class="zns-floor"></div>';
    document.body.insertBefore(stage, document.body.firstChild);

    var cv = stage.querySelector('canvas');
    var ctx = cv.getContext('2d');
    var stars = [], shoot = null, nextShoot = performance.now() + 4000, W, H;

    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      W = window.innerWidth; H = window.innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.min(160, Math.round(W * H / 11000));
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random() * W, y: Math.random() * H, z: 0.3 + Math.random() * 0.7, r: 0.4 + Math.random() * 1.3, a: 0.25 + Math.random() * 0.55, tw: 0.5 + Math.random() * 1.6, ph: Math.random() * 6.28, gold: Math.random() < 0.14 });
      }
    }
    size();
    window.addEventListener('resize', size);

    function draw(t) {
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        if (!reduced) { s.x -= 0.018 * s.z; if (s.x < -2) s.x = W + 2; }
        var tw = reduced ? 1 : (0.62 + 0.38 * Math.sin(t / 1000 * s.tw + s.ph));
        ctx.globalAlpha = s.a * tw;
        ctx.fillStyle = s.gold ? '#F2C457' : '#FAFAF9';
        ctx.beginPath(); ctx.arc(s.x, s.y, s.r * s.z, 0, 6.28); ctx.fill();
      }
      if (!reduced) {
        if (!shoot && t > nextShoot) { shoot = { x: W * (0.2 + Math.random() * 0.7), y: H * Math.random() * 0.4, vx: -(6 + Math.random() * 4), vy: 2.4 + Math.random() * 1.6, life: 1 }; }
        if (shoot) {
          shoot.x += shoot.vx; shoot.y += shoot.vy; shoot.life -= 0.022;
          var g = ctx.createLinearGradient(shoot.x, shoot.y, shoot.x - shoot.vx * 9, shoot.y - shoot.vy * 9);
          g.addColorStop(0, 'rgba(250,250,249,' + (0.85 * shoot.life) + ')');
          g.addColorStop(1, 'rgba(250,250,249,0)');
          ctx.strokeStyle = g; ctx.lineWidth = 1.6; ctx.lineCap = 'round';
          ctx.beginPath(); ctx.moveTo(shoot.x, shoot.y); ctx.lineTo(shoot.x - shoot.vx * 9, shoot.y - shoot.vy * 9); ctx.stroke();
          if (shoot.life <= 0 || shoot.x < -60 || shoot.y > H + 60) { shoot = null; nextShoot = t + 5000 + Math.random() * 6000; }
        }
      }
      ctx.globalAlpha = 1;
      if (!reduced && !document.hidden) requestAnimationFrame(draw);
    }
    requestAnimationFrame(draw);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && !reduced) requestAnimationFrame(draw); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* ===== ZNS v2: dark harmonizer + motion (perf-tuned, self-terminating) ===== */
(function () {
  'use strict';
  if (window.__znsMotion) return;
  window.__znsMotion = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SKIP = /^(SCRIPT|STYLE|IMG|SVG|PATH|VIDEO|CANVAS|IFRAME|BR|LINK|META)$/;
  function lum(c) {
    var m = c && c.match(/rgba?\(([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\)/);
    if (!m) return -1;
    if (m[4] !== undefined && parseFloat(m[4]) < 0.85) return -1;
    return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) / 255;
  }
  function harmonize() {
    try {
      var els = document.body.querySelectorAll('div, section, aside, table, ul, form, article');
      var n = Math.min(els.length, 1500), hits = [];
      for (var i = 0; i < n; i++) {
        var el = els[i];
        if (el.__znsSeen) continue;
        el.__znsSeen = 1;
        if (SKIP.test(el.tagName)) continue;
        if (el.closest('.zns-stage, .zns-invert, header, .shopify-section-group-header-group')) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 140 || r.height < 30) continue;
        if (lum(getComputedStyle(el).backgroundColor) > 0.78) hits.push(el);
      }
      for (var j = 0; j < hits.length; j++) hits[j].classList.add('zns-invert');
    } catch (e) {}
  }
  function runHarmonize() { if (window.requestIdleCallback) requestIdleCallback(harmonize, { timeout: 1000 }); else harmonize(); }

  function setupReveal() {
    if (reduced || !('IntersectionObserver' in window)) return;
    var targets = document.querySelectorAll('.card-wrapper, .product__info-container > *, .multicolumn-card, .collection-list__item');
    var batch = 0;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = ((batch++ % 8) * 55) + 'ms';
          e.target.classList.add('zns-in');
          io.unobserve(e.target);
        }
      });
      batch = 0;
    }, { threshold: 0.06, rootMargin: '0px 0px -4% 0px' });
    targets.forEach(function (t) {
      if (t.classList.contains('scroll-trigger')) return;
      t.classList.add('zns-reveal');
      io.observe(t);
    });
  }

  function setupTap() {
    if (reduced) return;
    document.body.addEventListener('pointerdown', function (e) {
      var b = e.target.closest('.button, .shopify-payment-button__button, .quick-add__submit');
      if (!b) return;
      b.classList.remove('zns-tap');
      void b.offsetWidth;
      b.classList.add('zns-tap');
    }, { passive: true });
  }

  function boot() {
    runHarmonize();
    setupReveal();
    setupTap();
    var pending = null;
    var mo = new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(runHarmonize, 400); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(runHarmonize, 1800);
    setTimeout(function () { runHarmonize(); mo.disconnect(); }, 6000);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();

/* ===== ZNS v3: colorful-widget reskin + sticky buy bar + spark burst (perf-tuned) ===== */
(function () {
  'use strict';
  if (window.__znsThrill) return;
  window.__znsThrill = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rgbParts(c) {
    var m = c && c.match(/rgba?\(([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.]+))?\)/);
    if (!m) return null;
    if (m[4] !== undefined && parseFloat(m[4]) < 0.85) return null;
    return [+m[1] / 255, +m[2] / 255, +m[3] / 255];
  }
  function hsl(p) {
    var r = p[0], g = p[1], b = p[2];
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var l = (max + min) / 2, d = max - min, s = 0, h = 0;
    if (d > 0) {
      s = d / (1 - Math.abs(2 * l - 1) || 1);
      if (max === r) h = ((g - b) / d) % 6;
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h = (h * 60 + 360) % 360;
    }
    return { h: h, s: s, l: l };
  }

  function reskinScan() {
    try {
      var els = document.querySelectorAll('#MainContent div, #MainContent section, #MainContent table, #MainContent form');
      var n = Math.min(els.length, 1200), hits = [];
      for (var i = 0; i < n; i++) {
        var el = els[i];
        if (el.__znsR) continue;
        el.__znsR = 1;
        if (el.closest('.zns-stage, .zns-reskin, .zns-invert, .zns-buybar')) continue;
        var r = el.getBoundingClientRect();
        if (r.width < 240 || r.height < 56) continue;
        var p = rgbParts(getComputedStyle(el).backgroundColor);
        if (!p) continue;
        var c = hsl(p);
        if (c.s > 0.45 && c.l >= 0.07 && c.l <= 0.6 && !(c.h >= 25 && c.h <= 60)) hits.push(el);
      }
      for (var j = 0; j < hits.length; j++) hits[j].classList.add('zns-reskin');
    } catch (e) {}
  }
  function runReskin() { if (window.requestIdleCallback) requestIdleCallback(reskinScan, { timeout: 1000 }); else reskinScan(); }

  function burst(x, y) {
    if (reduced || !document.body.animate) return;
    for (var i = 0; i < 14; i++) {
      var s = document.createElement('i');
      s.className = 'zns-spark';
      s.style.left = x + 'px';
      s.style.top = y + 'px';
      s.style.background = Math.random() < 0.3 ? 'radial-gradient(circle, #FAFAF9, #F6D584)' : 'radial-gradient(circle, #F6D584, #E8B23A)';
      document.body.appendChild(s);
      var a = Math.random() * 6.283;
      var v = 60 + Math.random() * 95;
      var dx = Math.cos(a) * v, dy = Math.sin(a) * v - 24;
      (function (el) {
        var anim = el.animate([
          { transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
          { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + dy + 'px)) scale(0)', opacity: 0 }
        ], { duration: 650 + Math.random() * 280, easing: 'cubic-bezier(0.16,1,0.3,1)' });
        anim.onfinish = function () { el.remove(); };
      })(s);
    }
  }
  document.body && document.body.addEventListener('click', function (e) {
    if (e.target.closest('.product-form__submit, .quick-add__submit')) burst(e.clientX, e.clientY);
  }, { passive: true });

  function setupBuyBar() {
    var btn = document.querySelector('.product-form__submit');
    if (!btn || document.querySelector('.zns-buybar')) return;
    var titleEl = document.querySelector('.product__title h1, h1.product__title, .product__info-container h1');
    var priceEl = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular');
    var bar = document.createElement('div');
    bar.className = 'zns-buybar';
    var info = document.createElement('div'); info.className = 'zns-bb-info';
    var t = document.createElement('span'); t.className = 'zns-bb-title';
    t.textContent = titleEl ? titleEl.textContent.trim() : 'This item';
    var pr = document.createElement('span'); pr.className = 'zns-bb-price';
    pr.textContent = priceEl ? priceEl.textContent.trim() : '';
    info.appendChild(t); info.appendChild(pr);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'zns-bb-btn'; b.textContent = 'Add to cart';
    bar.appendChild(info); bar.appendChild(b);
    document.body.appendChild(bar);
    b.addEventListener('click', function (e) {
      burst(e.clientX, e.clientY);
      btn.click();
      b.textContent = 'Added!';
      setTimeout(function () { b.textContent = 'Add to cart'; }, 1800);
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0];
        bar.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(btn);
    }
  }

  function boot() {
    runReskin();
    setupBuyBar();
    var pending = null;
    var mo = new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(runReskin, 450); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(runReskin, 2000);
    setTimeout(function () { runReskin(); mo.disconnect(); }, 6500);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
